/**
 * Type guard helpers for generated experiments
 *
 * These helpers provide type-safe access to Record<string, number> properties
 */
export const getParam = (params, key) => {
    const val = params[key];
    if (val === undefined)
        throw new Error(`Missing parameter: ${key}`);
    return val;
};
export const getState = (state, key) => {
    const val = state[key];
    if (val === undefined)
        throw new Error(`Missing state variable: ${key}`);
    return val;
};
/**
 * Extract the variables Record from a SimulationState for use in failureMode checks
 */
export const getStateValues = (state) => {
    return state.variables;
};
//# sourceMappingURL=helpers.js.map